import { render, staticRenderFns } from "./DocumentosComponent.vue?vue&type=template&id=087d6c06"
import script from "./DocumentosComponent.vue?vue&type=script&lang=js"
export * from "./DocumentosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports